import React from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import exportingInit from 'highcharts/modules/exporting';
import exportDataInit from 'highcharts/modules/export-data';

// Initialize the exporting and export data modules
exportingInit(Highcharts);
exportDataInit(Highcharts);

const DisaggregatedForecastChart = ({ data }) => {
    if (!data || !data.forecast_timestamps || !data.forecast_consumption) {
        return null;
    }

    const { forecast_timestamps, forecast_consumption } = data;

    // Transform timestamps into proper format for x-axis
    const formattedCategories = forecast_timestamps.map(timestamp => {
        const date = new Date(timestamp);
        return date.toLocaleString('en-US', {
            month: 'short',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        });
    });

    // Use a distinct deep blue color for total consumption that won't conflict with appliance colors
    const chartColor = '#1565C0'; // Deep Blue - distinct from appliance colors

    const chartOptions = {
        chart: {
            type: 'line',
            zoomType: 'x',
            panning: {
                enabled: true,
                type: 'x'
            },
            panKey: 'shift',
            resetZoomButton: {
                theme: {
                    fill: 'white',
                    stroke: '#bbb',
                    r: 3,
                    states: {
                        hover: {
                            fill: '#e6e6e6'
                        }
                    }
                },
                position: {
                    align: 'right',
                    verticalAlign: 'top',
                    x: -10,
                    y: 10
                }
            }
        },
        title: {
            text: null
        },
        subtitle: {
            text: 'Click and drag to zoom in. Hold Shift and drag to pan.',
            style: {
                fontSize: '11px',
                color: '#666'
            }
        },
        xAxis: {
            categories: formattedCategories,
            title: {
                text: 'Time'
            },
            labels: {
                rotation: -45,
                style: {
                    fontSize: '10px'
                }
            }
        },
        yAxis: {
            gridLineWidth: 0,
            title: {
                text: 'Consumption (Wh)'
            }
        },
        tooltip: {
            crosshairs: true,
            shared: true,
            valueSuffix: ' Wh',
            formatter: function () {
                return `<b>${forecast_timestamps[this.point.index]}</b><br/>
                        Consumption: <b>${this.y.toFixed(2)} kWh</b>`;
            }
        },
        series: [
            {
                name: 'Disaggregated Forecast Consumption',
                type: 'line',
                data: forecast_consumption,
                color: chartColor,
                marker: {
                    enabled: true,
                    radius: 3
                },
                lineWidth: 2
            }
        ],
        exporting: {
            enabled: true
        },
        credits: {
            enabled: false
        },
        accessibility: {
            enabled: false
        }
    };

    return (
        <HighchartsReact
            highcharts={Highcharts}
            options={chartOptions}
            containerProps={{ style: { height: '100%', width: '100%' } }}
        />
    );
};

export default DisaggregatedForecastChart; 